import React, { useState } from 'react'
import RdnaTextInput from '@ringdna/common/src/components/RdnaFormElements/RdnaTextInput'

type Props = {
  user: any
  field: string
  disabled: boolean
}

export default function NumberCell({ user, field, disabled }: Props) {
  const [value, setValue] = useState<string>(user[field])
  return (
    <RdnaTextInput
      className={'sn-cell-text'}
      onChange={({ target: { value } }) => {
        setValue(value)
        user[field] = value
      }}
      type="number"
      value={value}
      disabled={disabled}
      name={field}
    />
  )
}
